import {BS2GameAssets} from "../BS2GameAssets";
import {BS2} from "../BS2";
import {BetWayWin} from "../server/BS2Data";
import {gsap} from "gsap";
import {BS2Statics} from "../config/BS2Statics";

/**
 * Created by jonas on 2022-09-05.
 */

export class LineWinDisplay extends PIXI.Container {
    private _winAmount: PIXI.BitmapText;
    private _ways: PIXI.Text;

    constructor(betWayWin: BetWayWin) {
        super();
        this.name = betWayWin.symbol + betWayWin.multipliedAmount;
        this._winAmount = new PIXI.BitmapText(BS2.apiPlugin.currency.formatValue(betWayWin.amount), {
            fontName: BS2GameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 60,
            tint: 0xffffff
        });


        const _waysEnding: string = BS2.apiPlugin.translations.translate(betWayWin.numberOfCombinations > 1 ? "Ways" : "Way");
        this._ways = new PIXI.Text(betWayWin.numberOfCombinations + " " + _waysEnding, {
            "fill": "#e82c2c",
            "fillGradientStops": [
                10
            ],
            "fontSize": 25,
            "fontWeight": "bolder",
            "letterSpacing": 1,
            "lineJoin": "round",
            "miterLimit": 0,
            "stroke": "#030303",
            "strokeThickness": 8
        });


        if (betWayWin.multiplier > 1) {
            this._winAmount.text += ` x ${betWayWin.multiplier}`;
        }

        this._winAmount.anchor = new PIXI.Point(0.5, 1);
        this._winAmount.position.set(0, 0);

        this._ways.anchor = new PIXI.Point(0.5, 0);
        this._ways.position.set(0, -6);
        this.resizeAmountSize(this._winAmount);
        this.reSizeWaysSize(this._ways);
        this.addChild(this._winAmount, this._ways);
    }

    public getAnimation(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(gsap.to(this, {duration: 0.01, alpha: 1}));
        tl.add(gsap.to(this, {duration: 0.55, y: this.y - 15}));
        tl.add(gsap.to(this, {duration: 0.3, alpha: 0}), "<0.25");

        return tl;
    }

    private resizeAmountSize(obj: PIXI.BitmapText): void {
        if (obj.width > BS2Statics.SYMBOL_WIDTH - 40) {
            let fontSize: number = obj.fontSize;
            while (obj.width > BS2Statics.SYMBOL_WIDTH - 20) {
                obj.fontSize = fontSize;
                --fontSize;
            }
        }
    }

    private reSizeWaysSize(obj: PIXI.Text): void {
        if (obj.width > BS2Statics.SYMBOL_WIDTH - 40) {
            let fontSize: number = obj.style.fontSize;
            while (obj.width > BS2Statics.SYMBOL_WIDTH - 40) {
                obj.style.fontSize = fontSize;
                --fontSize;
            }
        }
    }
}